import React from "react";

function ClientCover() {
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="w-full md:w-11/12 py-10 px-2 md:px-10 gap-x-10 flex justify-center items-center bg-black bg-opacity-20 rounded-lg">
        <div className="w-1/2 md:3/5 flex flex-col px-2 md:px-10 gap-y-5">
          <h1 className="text-2xl md:text-6xl">We partner with the world's best clients</h1>
          <p className="hidden md:block w-2/3 text-xl text-slate-300">
            Let's help you boost productivity, solve problems and enhance your
            technical services. Walking the journey with you as your technical
            solutions partner.
          </p>
          <div className="w-2/3 flex justify-evenly text-base gap-x-2 md:text-xl">
            <button className="bg-white bg-opacity-20 rounded-lg p-1 md:px-5 md:py-3 shadow-xl border border-slate-100">
              View Our Team
            </button>
            <button className="bg-black bg-opacity-20 rounded-lg p-1 md:px-5 md:py-3 shadow-xl border border-slate-100">
              Get In Touch
            </button>
          </div>
        </div>
        <div className="relative w-1/2 md:w-2/5 flex justify-center items-center">
          <div className="w-4/5 h-72 bg-cyan-600 bg-opacity-50 rounded-lg"></div>
          <img
            src="serviceImg/content.png"
            alt="serviceImage"
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}

export default ClientCover;
